module.exports = __webpack_public_path__ + "static/desktop/img/Paypal.0eeced2d.svg";